/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ManagedEmployeesLeisureAndVacationAccountsResponse } from '../models/ManagedEmployeesLeisureAndVacationAccountsResponse';
import type { TimeAccountsMeResponse } from '../models/TimeAccountsMeResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TimeAccountsService {
    /**
     * returns leisure time account and vacation entitlement for current employee
     * @returns TimeAccountsMeResponse returns both accounts for blue collar worker
     * @throws ApiError
     */
    public static getMyTimeAccounts(): CancelablePromise<TimeAccountsMeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/time_management/time_accounts/me',
        });
    }
    /**
     * returns leisure time accounts and vacation summaries for the managed employees
     * @param tenantId tenant_id
     * @param startDate first day of the period; vacation_by_year covers each of its years
     * @param endDate last day of the period
     * @returns ManagedEmployeesLeisureAndVacationAccountsResponse returns a vacation summary for each year of the period
     * @throws ApiError
     */
    public static getManagedEmployeesLeisureAndVacationAccounts(
        tenantId: string,
        startDate?: string,
        endDate?: string,
    ): CancelablePromise<ManagedEmployeesLeisureAndVacationAccountsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/time_management/time_accounts/managed_employees',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                400: `rejects a period over more than two calendar years`,
            },
        });
    }
}
